import { RichtextValue } from "@robe/core";
import _getSlug from "speakingurl";
import _sanitizeHtml from "sanitize-html";

/**
 * Sanitizes HTML before render (adds closing html tags if missing and stuff like that).
 * Returns `null` if HTML structure is broken and cannot be sanitized.
 * Not a final solution. HTML structure validation will be added to richtext after xcc
 * as node 18 or higher is needed for `html-validate` package.
 */
export const sanitizeHtml = (htmlString: string) => {
  const sanitized = _sanitizeHtml(htmlString, {
    // Allow iframes as children + allow styling
    allowedTags: _sanitizeHtml.defaults.allowedTags.concat(["iframe"]),
    allowedAttributes: {
      div: ["style"],
      iframe: ["src", "style"],
    },
    allowedStyles: {
      "*": {
        "text-align": [/^(?:left|right|center|justify)$/],
        "width": [/^(?:\d+px|\d+%)$|^0$/],
        "min-width": [/^\d+px$|^0$/],
        "max-width": [/^\d+px$|^0$/],
        "min-height": [/^\d+px$|^0$/],
        "max-height": [/^\d+px$|^0$/],
        "border": [/^0$|^\d+px(?:\s+\w+)?$/],
        "overflow": [/^(?:hidden|auto|scroll|visible)$/],
        "box-shadow": [/^[\d\s]+px\s[\d\s]+px\s[\d\s]+px\s[\w()#.,\s-]+$/],
      },
    },
  });

  return sanitized.trim().length > 0 ? sanitized : null;
};

/**
 * Deletes last line if it is an empty paragraph.
 * This empty line is desired while editing the richtext for possible further inserts, but non-desired while rendering its content.
 **/
export const sanitizeRichtextContent = (content: RichtextValue | undefined): RichtextValue | undefined => {
  if (content?.value.length) {
    const lastItem = content.value[content.value.length - 1] as any; // as any because leafs do not have correct types

    if (lastItem.type === "paragraph" && "text" in lastItem.children[0] && lastItem.children[0].text === "") {
      content.value.pop();
    }
  }

  return content;
};

export const getIdSlug = (value: any[]): string => {
  return _getSlug(value.map((child) => child.text).join(""), { truncate: 50 });
};
